// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style-module__not-found-page___gFunz {\n  h1 {\n    font-size: 2em;\n    margin-bottom: 0.25em;\n  }\n}\n", "",{"version":3,"sources":["webpack://./app/containers/NotFoundPage/style.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,cAAc;IACd,qBAAqB;EACvB;AACF","sourcesContent":[".not-found-page {\n  h1 {\n    font-size: 2em;\n    margin-bottom: 0.25em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"not-found-page": "style-module__not-found-page___gFunz"
};
export default ___CSS_LOADER_EXPORT___;
